(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/assets/javascripts/views/result-page.js') >= 0) return;  svs.modules.push('/modules/lotto/assets/javascripts/views/result-page.js');

'use strict';

svs.lotto.views.ResultPage = Marionette.View.extend({
  viewOptions: ['dateString'],
  dateString: undefined,
  behaviors: [{
    behaviorClass: svs.numbergames.game_app.behaviors.LoadModuleComponent,
    module: 'lotto',
    component: 'result'
  }],
  regions: {
    resultRegion: '#ngResultRegion'
  },
  template() {
    return svs.lotto.templates.result_page();
  },
  initialize() {
    this.mergeOptions(this.options, this.viewOptions);
  },
  onRender() {
    if (svs.lotto.components.result) {
      this.showChildView('resultRegion', new svs.lotto.components.result.views.Result({
        selectedDate: this.dateString
      }));
    }
  }
});

 })(window);